<script setup lang="ts">
import { IconCheckmark } from "@iconify-prerendered/vue-carbon";

// Props
type Props = {
  helpText?: string;
  label?: string;
  name: string;
  placeholder?: string;
  disabled?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  helpText: "",
  type: "text",
  label: "",
  placeholder: "",
  disabled: false
});

const model = defineModel<boolean>();

</script>

<template>
  <div
    v-bind="props"
    class="flex gap-3 align-center items-center select-none"
    @click="model = !model"
  >
    <div>
      <div class="checkbox-box">
        <IconCheckmark class="checkbox-box-mark" v-if="model" />
      </div>
    </div>
    <span>
      <slot />
    </span>
  </div>
</template>

<style scoped lang="scss">
.checkbox-box {
  display: block;
  background-color: rgba(31, 41, 55, 0.5); /* bg-gray-800/50 */
  border: 2px solid rgba(156, 163, 175, 0.5); /* border-gray-400/50 */
  width: 24px;
  height: 24px;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}

.checkbox-box:hover {
  border: 2px solid #3b82f6; /* blue-500 */
  background-color: rgba(31, 41, 55, 0.7);
}

.checkbox-box-mark {
  color: #3b82f6; /* blue-500 */
  width: 100%;
  height: 100%;
}
</style>
